<!-- HEADER -->
<div class="mb-6 px-3">
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
    <div class="border-l-4 border-gray-800 pl-4">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Repeated Posts Section
      </p>

      <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
        List
      </h2>
    </div>
  </div>
</div>

<!-- CONTENT WRAPPER -->
<div class="bg-gray-50 px-3 pb-10 min-h-screen pt-6">
  <div class="grid grid-cols-12 gap-6 items-start">

    <!-- MAIN CONTENT -->
    <div class="col-span-12 2xl:col-span-9">

      <!-- DESKTOP TABLE -->
      <div class="hidden lg:block">

        <!-- Header Row -->
        <div
          class="grid items-center gap-x-4 px-4 pb-3 text-xs font-semibold uppercase tracking-wider text-gray-400"
          style="grid-template-columns: 2.2fr 1.2fr 1fr 1fr 1.1fr 1.4fr 120px;">
          <span>Title / Site</span>
          <span>Category</span>
          <span>Platform</span>
          <span>Day</span>
          <span>Scheduled</span>
          <span>Article</span>
          <span>Status</span>
        </div>

        <!-- Rows -->
        <div
          *ngFor="let row of dataSource.data; trackBy: trackById"
          class="grid items-center gap-x-4 px-5 py-4 mb-3 rounded-2xl border border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm transition-all duration-150 cursor-pointer"
          style="grid-template-columns: 2.2fr 1.2fr 1fr 1fr 1.1fr 1.4fr 120px;"
          (click)="viewRow(row)">

          <!-- Title -->
          <div class="min-w-0">
            <p
              class="mb-1 text-sm font-semibold text-gray-900 truncate"
              [matTooltip]="row.post_title">
              {{ row.post_title || '—' }}
            </p>

            <p class="text-xs text-gray-400 truncate">
              <i class="ti ti-world mr-1"></i>
              {{ row.Domain || '—' }}
              <span *ngIf="row.tag">· {{ row.tag }}</span>
            </p>
          </div>

          <!-- Category -->
          <span class="text-sm text-gray-600 truncate">
            {{ row.feed || '—' }}
          </span>

          <!-- Platform -->
          <div>
            <span class="inline-flex items-center gap-1.5 px-3 py-1 text-xs rounded-full border border-gray-200 bg-gray-50 text-gray-700">
              <i class="ti {{ platformIconClass(row.platform) }}"></i>
              {{ row.platform || '—' }}
            </span>
          </div>

          <!-- Week -->
          <span class="text-sm text-gray-600">
            {{ weekDays[row.week_day] || '—' }}
          </span>

          <!-- Date -->
          <div class="text-sm text-gray-700 leading-relaxed">
            <div>
              {{ row.scheduled_for | date:'dd/MM/yyyy' }}
            </div>

            <div class="text-xs text-gray-400">
              {{ row.scheduled_for | date:'HH:mm' }}
            </div>
          </div>

          <!-- Article -->
          <a
            [href]="row.article_url"
            target="_blank"
            rel="noopener noreferrer"
            class="text-sm text-blue-600 hover:underline truncate"
            (click)="$event.stopPropagation()">
            {{ row.article_url || '—' }}
          </a>

          <!-- Status -->
          <div>
            <span
              class="inline-flex items-center px-3 py-1 text-xs rounded-full font-medium"
              [ngClass]="{
                'bg-blue-50 text-blue-700': statusBadgeClass(row.post_status) === 'badge-blue',
                'bg-green-50 text-green-700': statusBadgeClass(row.post_status) === 'badge-green',
                'bg-amber-50 text-amber-700': statusBadgeClass(row.post_status) === 'badge-amber',
                'bg-gray-100 text-gray-600': statusBadgeClass(row.post_status) === 'badge-gray'
              }">
              {{ postStatusForm(row.post_status) || '—' }}
            </span>
          </div>

        </div>

        <!-- Empty -->
        <div
          *ngIf="dataSource.data.length === 0"
          class="flex items-center justify-center py-16 text-gray-400 text-sm bg-white border border-gray-200 rounded-2xl">
          <i class="ti ti-inbox text-2xl mr-2"></i>
          No repeated posts found
        </div>

      </div>

      <!-- MOBILE -->
      <div class="block lg:hidden">

        <div
          *ngFor="let row of dataSource.data; trackBy: trackById"
          class="mb-3 p-4 rounded-2xl border border-gray-200 bg-white hover:border-gray-300 transition"
          (click)="viewRow(row)">

          <div class="flex justify-between gap-2 mb-2">
            <p class="text-sm font-semibold text-gray-900 line-clamp-2 flex-1">
              {{ row.post_title || '—' }}
            </p>

            <span
              class="text-xs px-2 py-0.5 rounded-full font-medium"
              [ngClass]="{
                'bg-blue-50 text-blue-700': statusBadgeClass(row.post_status) === 'badge-blue',
                'bg-green-50 text-green-700': statusBadgeClass(row.post_status) === 'badge-green',
                'bg-amber-50 text-amber-700': statusBadgeClass(row.post_status) === 'badge-amber',
                'bg-gray-100 text-gray-600': statusBadgeClass(row.post_status) === 'badge-gray'
              }">
              {{ postStatusForm(row.post_status) }}
            </span>
          </div>

          <div class="grid grid-cols-2 gap-2 text-xs text-gray-500">
            <span>{{ row.Domain || '—' }}</span>
            <span>{{ row.scheduled_for | date:'dd/MM/yy HH:mm' }}</span>
            <span>{{ weekDays[row.week_day] || '—' }}</span>
            <span>{{ row.feed || '—' }}</span>
            <span>{{ row.tag || '—' }}</span>
          </div>

          <div class="flex justify-between items-center mt-3 pt-2 border-t border-gray-100">
            <span class="px-2 py-0.5 text-xs rounded-full bg-gray-50 border border-gray-200">
              {{ row.platform || '—' }}
            </span>

            <a
              [href]="row.article_url"
              target="_blank"
              rel="noopener noreferrer"
              class="text-xs text-blue-600 truncate max-w-[160px]"
              (click)="$event.stopPropagation()">
              {{ row.article_url || '—' }}
            </a>
          </div>

        </div>

        <div
          *ngIf="dataSource.data.length === 0"
          class="flex items-center justify-center py-12 text-gray-400 text-sm bg-white border border-gray-200 rounded-2xl">
          <i class="ti ti-inbox text-2xl mr-2"></i>
          No repeated posts found
        </div>

      </div>

      <!-- Paginator -->
      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageSizeOptions]="[pageSize]"
        showFirstLastButtons
        (page)="onPageChange($event)"
        class="mt-6">
      </mat-paginator>

    </div>

    <!-- SIDEBAR -->
    <div
      class="hidden 2xl:block col-span-3"
      *ngIf="posts.length > 0 || alerts.length > 0">

      <app-latest-posts
        class="mb-4"
        [posts]="posts"
        [maxSidebarCards]="3"
        [naPlaceholder]="naPlaceholder"
        (viewPost)="viewLatestPost($event)">
      </app-latest-posts>

      <app-latest-alerts
        [alerts]="alerts"
        [maxSidebarCards]="3"
        [naPlaceholder]="naPlaceholder"
        (viewAlert)="viewLatestAlert($event)">
      </app-latest-alerts>

    </div>

  </div>
</div>